import { Context } from 'src/models/Context';
import { swrFetch } from 'src/utils/swrFetch';
import useSWR from 'swr';

export const useMe = () => {
    return useSWR<Context>('/users/me', swrFetch);
};
